/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesOrganizationSchema } from "./organizationSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesOrganizationSubscriptionSchema = z.object({
  id: z.string().nullish(),
  organizationId: z.uuid(),
  get organization() {
    return goodLuckCoreEntitiesOrganizationSchema.optional();
  },
  userId: z.string().min(1),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  createdAt: z.optional(z.iso.datetime()),
});
